import { forwardRef, createElement } from 'react';

function IconEdit(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20.25 20.5a.75.75 0 110 1.5H3.75a.75.75 0 110-1.5h16.5zM16.013 2.927a1.75 1.75 0 012.35-.114l.124.114 1.586 1.586a1.75 1.75 0 01.114 2.35l-.114.124L8.061 19H4v-4.06L16.013 2.926zM14.499 6.56l-8.999 9v1.94h1.938l9-9-1.939-1.94zm2.928-2.573a.25.25 0 00-.3-.04l-.054.04L15.56 5.5l1.939 1.94 1.514-1.512a.25.25 0 00.065-.24l-.025-.06-.04-.054-1.586-1.586z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Edit = /*#__PURE__*/forwardRef(IconEdit);

export default Edit;
//# sourceMappingURL=Edit.js.map
